<button *ngIf="fileList.length == 1"
        nz-button
        [nzType]="'primary'"
        [nzLoading]="importDone"
        (click)="handleUpload()"
        [disabled]="fileList.length === 0"
        style="margin-top: 16px"
>
  {{ importDone ? 'Đang upload file..' : 'Xử lý dữ liệu' }}
</button>
<nz-upload [(nzFileList)]="fileList" [nzBeforeUpload]="beforeUpload" [nzLimit]="1"
           [nzFileType]="fileTypes"
           [nzAccept]="fileTypes"
           [nzName]="fileName"
           [nzSize]="limitSize" [nzShowButton]="fileList.length == 0">
    <button nz-button *ngIf="fileList.length == 0">
      <span nz-icon nzType="upload"></span>
      {{ title }}
    </button>
</nz-upload>

